"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAddressString = exports.stripHTML = exports.getDateTimeString = exports.pushState = exports.difference = exports.getFormatForField = exports.getExpandsFromSelects = exports.getQueryStrings = exports.decodeTokenPayload = exports.base64Decode = void 0;
const z = __importStar(require("."));
const lodash_1 = require("lodash");
const index_1 = require("./index");
const lodash_2 = __importDefault(require("lodash"));
require("./string.extensions");
window.zeact = z;
exports.base64Decode = (data) => new Buffer(data, "base64").toString("ascii");
exports.decodeTokenPayload = (token) => {
    const tokenPayloadString = token.split(".")[1];
    const payload = exports.base64Decode(tokenPayloadString);
    return JSON.parse(payload);
};
exports.getQueryStrings = () => {
    const queryStrings = {};
    const queryString = document.location.search;
    const trimmed = queryString.substring(1);
    const splitQuery = trimmed.split("&");
    splitQuery.forEach(kv => {
        const splitKV = kv.split("=");
        queryStrings[splitKV[0]] = splitKV[1];
    });
    return queryStrings;
};
exports.getExpandsFromSelects = (selects) => {
    const expands = [];
    lodash_2.default.each(selects, function (value, index) {
        value = value.replaceAll(".", "/");
        if (value.indexOf("/") != -1) {
            var newExpand = value.substr(0, value.lastIndexOf("/"));
            expands.push(lodash_2.default.trim(newExpand));
        }
    });
    if (expands.length === 0) {
        return undefined;
    }
    return lodash_2.default.uniq(expands).sort();
};
exports.getFormatForField = (field) => {
    let formatCode;
    const property = index_1.getSchemaProperty(field.replaceAll("/", "."));
    if (!property) {
        return undefined;
    }
    const type = property.Type;
    if (type === "Currency") {
        formatCode = "c";
    }
    else if (type === "Int32") {
        formatCode = "n";
    }
    else if (type === "Decimal") {
        formatCode = field.endsWith("Percent") ? "p" : "n2";
    }
    else if (type === "Date") {
        formatCode = "d";
    }
    return formatCode;
};
/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
function difference(object, base) {
    return lodash_2.default.transform(object, (result, value, key) => {
        if (!lodash_2.default.isEqual(value, base[key])) {
            result[key] =
                lodash_2.default.isObject(value) && lodash_2.default.isObject(base[key])
                    ? difference(value, base[key])
                    : value;
        }
    });
}
exports.difference = difference;
exports.pushState = (title, route) => {
    const currentPath = document.location.pathname;
    if (currentPath.toLowerCase() === route.toLowerCase()) {
        document.title = title;
        return true;
    }
    window.history.pushState({}, title, route);
    return true;
};
exports.getDateTimeString = () => {
    const date = new Date();
    let dateStr = `${date.getFullYear()}`;
    dateStr +=
        date.getMonth() + 1 < 10
            ? `0${date.getMonth() + 1}`
            : (date.getMonth() + 1).toString();
    dateStr +=
        date.getDate() < 10 ? `0${date.getDate()}` : date.getDate().toString();
    dateStr +=
        date.getHours() < 10 ? `0${date.getHours()}` : date.getHours().toString();
    dateStr +=
        date.getMinutes() < 10
            ? `0${date.getMinutes()}`
            : date.getMinutes().toString();
    dateStr +=
        date.getSeconds() < 10
            ? `0${date.getSeconds()}`
            : date.getSeconds().toString();
    return dateStr;
};
// Helper function for stripHTML.
function parseHTML(html) {
    var element = document.createElement("div");
    element.innerHTML = html;
    return element.childNodes;
}
// Helper function for stripHTML.
function stripRecursive(args) {
    var result = "";
    args.keepStyling = args.keepStyling === undefined ? false : args.keepStyling;
    args.insertLineBreaks =
        args.insertLineBreaks === undefined ? false : args.insertLineBreaks;
    if (!args.html) {
        return "";
    }
    args.html = args.html.replaceAll(new RegExp("<br[ ]*/>"), args.insertLineBreaks ? "\n" : "&nbsp");
    var elements = parseHTML(args.html);
    elements.forEach((element) => {
        if (element.nodeName === "#text") {
            result += `${element.textContent}`;
        }
        else {
            var content = "";
            args.html = element.innerHTML;
            switch (element.nodeName) {
                case "STRONG":
                    if (args.keepStyling) {
                        content = `<strong>${stripRecursive(args)}</strong>`;
                    }
                    else {
                        content = `${stripRecursive(args)}`;
                    }
                    break;
                case "EM":
                    if (args.keepStyling) {
                        content = `<em>${stripRecursive(args)}</em>`;
                    }
                    else {
                        content = `${stripRecursive(args)}`;
                    }
                    break;
                case "SPAN":
                    if (args.keepStyling) {
                        content = `<span style="${element.style.cssText}">${stripRecursive(args)}</span>`;
                    }
                    else {
                        content = `${stripRecursive(args)}`;
                    }
                    break;
                default:
                    content = `${stripRecursive(args)}`;
            }
            result += content;
        }
    });
    return result;
}
// Strips HTML out of a string.
// Args
// html: A string of html to be modified.
// keepStyling: Does not remove tags that just style text. Default is false.
// insertLineBreaks: Adds a line break at the end of text stripped from li tags.
//                   If false, then spaces will be inserted. Default is false.
function stripHTML(args) {
    // Insert breaks into places that'll become new lines or spaces
    args.html = args.html.replaceAll(new RegExp("<div><br[ ]*/></div>"), "<br/>");
    args.html = args.html.replaceAll("<div>", "<br/><div>");
    args.html = args.html.replaceAll("</li><li>", "</li><br/><li>");
    args.html = args.html.replaceAll("<ul>", "<br/><ul>");
    args.html = args.html.replaceAll("</p><p>", "</p><br/><p>");
    if (args.html.startsWith("<br/>")) {
        args.html = args.html.substring(5);
    }
    var result = stripRecursive(args);
    return result;
}
exports.stripHTML = stripHTML;
exports.buildAddressString = (data) => {
    data = data || {};
    let addressLines = [];
    if (data.Address1) {
        const address1 = lodash_1.escape(data.Address1);
        addressLines.push(address1);
    }
    if (data.Address2) {
        const address2 = lodash_1.escape(data.Address2);
        addressLines.push(address2);
    }
    if (data.Address3) {
        const address3 = lodash_1.escape(data.Address3);
        addressLines.push(address3);
    }
    let cityStateZip = "";
    if (data.City) {
        const City = lodash_1.escape(data.City);
        cityStateZip += City;
    }
    if (data.City && data.Region) {
        cityStateZip += ", ";
    }
    if (data.Region) {
        const Region = lodash_1.escape(data.Region);
        cityStateZip += Region;
    }
    cityStateZip += " ";
    if (data.PostalCode) {
        const PostalCode = lodash_1.escape(data.PostalCode);
        cityStateZip += PostalCode;
    }
    addressLines.push(cityStateZip);
    if (data.Country) {
        addressLines.push(data.Country);
    }
    if (addressLines.length <= 0) {
        return "---";
    }
    const lineBreak = "\n";
    let retVal = addressLines.join(lineBreak);
    if (retVal.trim() === "") {
        return "---";
    }
    return retVal;
};
//# sourceMappingURL=utils.js.map